<script>
  import { saveAs } from "file-saver";
  import { createEventDispatcher, onMount } from "svelte";
  import { fade } from "svelte/transition";
  import { Button, Spinner } from "sveltestrap";
  import AppIconDraw from "./AppIconDraw.svelte";
  import ImgFullPreview from "./ImgFullPreview.svelte";
  import { APP_NAME, putPresetGlobal } from "./db";
  import JSZip from "./jszip";
  import store from "./store";
  import l from "./utils/locale";
  import { _err, _log } from "./utils/logger";
  import {
    base64Resize,
    dataURLtoBase64,
    dateToLocaleString,
    shareImage,
  } from "./utils/util";

  const dispatch = createEventDispatcher();

  export let images = [];
  export let options = {};
  let imagesUrls = [];
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  let map = new Map();
  let imgFullPreview;
  let ID_COUNT = 1;
  let isLoadingDownload = false;
  $: if (images) {
    const urls = [];
    for (const image of images) {
      if (map.has(image.url)) {
        urls.push(map.get(image.url));
        continue;
      }
      _log("image", image);
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image.url, 0, 0);
      const url = canvas.toDataURL();
      const result = {
        url,
        name: image.name,
        title: image.name.substring(0, image.name.lastIndexOf(".")),
        width: image.width,
        height: image.height,
        id: image.id,
      };
      urls.push(result);
      map.set(image.url, result);
    }
    imagesUrls = urls;
  }

  let mainEl;

  onMount(() => {
    _log("onMount");
    try {
      let app_iDCount = localStorage.getItem(APP_NAME + "app_iDCount") || "1";
      ID_COUNT = parseInt(app_iDCount);
    } catch (error) {}
    return () => {
      localStorage.setItem(APP_NAME + "app_iDCount", `${ID_COUNT}`);
      store.setValue("iDCount", ID_COUNT);
    };
  });

  function removeFileHandler(img) {
    map.delete(img.url);
    dispatch("onFiles", { data: { img, action: "remove" } });
  }

  function showImage(img) {
    imgFullPreview = img;
  }

  function onClickImage() {
    imgFullPreview = "";
  }

  function clearFiles() {
    imagesUrls = [];
    map.clear();
    imgFullPreview = "";
    dispatch("onFiles", { data: { action: "clear" } });
  }

  function getImageName(name) {
    try {
      return name.substring(0, name.lastIndexOf("."));
    } catch (error) {
      console.error(error);
      return name;
    }
  }

  function getImageType(name) {
    _log("getImageType", options.isOriginalType, options.type);
    let imageType = "jpeg";
    try {
      if (
        !options.isOriginalType &&
        options.type !== "---" &&
        options.type !== "zip" &&
        options.type !== "pdf" &&
        options.type !== "svg" &&
        options.type !== "html"
      ) {
        imageType = options.type;
      } else {
        imageType = name.substring(name.lastIndexOf(".") + 1).toLowerCase();
        if (imageType === "gif") {
          imageType = "png";
        }
      }
      _log("getImageType", options);
    } catch (error) {
      imageType = "jpeg";
    }
    return imageType;
  }

  async function savePreset() {
    try {
      const btnSvaePreset = document.querySelector(".btnSvaePreset");
      if (btnSvaePreset) btnSvaePreset.style.display = "none";
      const preset = { ...options };
      const id = dateToLocaleString();
      const img = imagesUrls[0];
      if (img) {
        const cover = await base64Resize(img.url, {
          ratio: true,
          width: 320,
          height_0: img.height,
          width_0: img.width,
          quality: 10,
        });
        preset.id = id;
        preset.cover = cover;
        preset.files = null;
        putPresetGlobal({ id, preset });
      }
    } catch (error) {
      _err(error);
    }
  }

  function setDownloadDone() {
    isLoadingDownload = false;
    clearFiles();
  }
  function downloadData(data, type, mime) {
    const file_name = `Image Editor Bulk ${new Date().toLocaleDateString()}`;
    const blob = new Blob([data], { type: mime });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    const fileName = `${file_name}.${type}`;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
    setDownloadDone();
  }
  function downloadFiles() {
    isLoadingDownload = true;
    _log("downloadFiles", options);
    const images = imagesUrls;
    if (options.type === "pdf") {
      const workerPath = `js/image_to_pdf.worker.js`;
      const worker = new Worker(workerPath, { type: "module" });
      worker.addEventListener("message", async (e) => {
        if (e.data.type === "done") {
          const data = e.data.buffer;
          downloadData(data, "pdf", "application/pdf");
        }
      });
      worker.postMessage({
        type: "start",
        data: { itemsUpload: images },
      });
    } else if (options.type === "svg") {
      const workerPath = `js/image_to_svg.worker.js`;
      const worker = new Worker(workerPath, { type: "module" });
      worker.addEventListener("message", async (e) => {
        if (e.data.type === "done") {
          const data = e.data.buffer;
          for (const element of data) {
            const file_name = element.name;
            const blob = new Blob([element.data], {
              type: "image/svg+xml",
            });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.href = url;
            const fileName = `${file_name}.svg`;
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(url);
          }
          setDownloadDone();
        }
      });
      worker.postMessage({
        type: "start",
        data: { itemsUpload: images },
      });
    } else if (options.type === "html") {
      let buffer = `<!DOCTYPE html>
    <html lang="en">
    
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Images</title>
      <style>
        .gallery {
        display:flex;
        flex-direction:column;
        flex-wrap:wrap;
        justify-content:center;
        }
        .gallery img{
        margin-top:10px;
        object-fit:scale-down;
        width:100%;
        }
      </style>
      </head>
    
    <body>
      <div class="gallery">
      `;
      for (const [_, image] of images.entries()) {
        buffer += `<img src='${image.url}'/>`;
      }
      buffer += `
    </div>
    </body>

</html>
    `;

      downloadData(buffer, "html", "text/html");
    } else if (options.type === "zip") {
      const zip = new JSZip();
      let count = 1;
      for (const [i, image] of images.entries()) {
        let imageName = image.name;
        if (options.autocrop) {
          const _fileName = `${getImageName(imageName)}_${ID_COUNT++}.${getImageType(imageName)}`;
          zip.file(_fileName, dataURLtoBase64(image.url), {
            base64: true,
          });
        } else {
          const _fileName = `${getImageName(imageName)}.${getImageType(imageName)}`;
          zip.file(_fileName, dataURLtoBase64(image.url), {
            base64: true,
          });
        }
      }

      zip
        .generateAsync({
          type: "blob",
        })
        .then(function (content) {
          saveAs(
            content,
            `Images ${new Date().toLocaleDateString("en-US", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}`
          );
          setDownloadDone();
        });
    } else {
      for (const [i, image] of images.entries()) {
        try {
          const imageName = image.name;
          const imageType = getImageType(imageName);
          const type = "image/" + imageType;
          const _fileName = `${getImageName(imageName)}_${ID_COUNT++}.${imageType}`;
          _log("_fileName", _fileName);
          const link = document.createElement("a");
          link.setAttribute(
            "href",
            image.url.replace(type, "image/octet-stream")
          );
          link.setAttribute("download", _fileName);
          link.click();
        } catch (error) {
          _err(error);
        }
      }
      setDownloadDone();
    }
  }
</script>

<div class="btn-flex-sb">
  {#if imagesUrls.length > 0}
    <Button color="danger" on:click={clearFiles}
      ><svg
        xmlns="http://www.w3.org/2000/svg"
        class="ionicon"
        viewBox="0 0 512 512"
        ><title>{l["clear_all"]}</title><path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="32"
          d="M368 368L144 144M368 144L144 368"
        /></svg
      >
      <div>
        {l["clear"]}
      </div>
    </Button>
    <Button color="primary" class="btnSvaePreset" on:click={savePreset}>
      <AppIconDraw name="save-preset" />
      <div>
        {l["save_preset"]}
      </div>
    </Button>
    {#if isLoadingDownload}
      <Button color="success" on:click={() => {}}>
        <Spinner color="white" size="sm" />
      </Button>
    {:else}
      <Button color="success" on:click={downloadFiles}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="ionicon"
          viewBox="0 0 512 512"
          ><title>{l["download"]}</title><path
            d="M336 176h40a40 40 0 0140 40v208a40 40 0 01-40 40H136a40 40 0 01-40-40V216a40 40 0 0140-40h40"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="32"
          /><path
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="32"
            d="M176 272l80 80 80-80M256 48v288"
          /></svg
        >

        <div>
          {l["download"]}
        </div>
      </Button>
    {/if}
  {/if}
</div>

<div class="files-main proccess" bind:this={mainEl}>
  {#if imagesUrls.length}
    <div class="app-files">
      {#each imagesUrls as img}
        <div
          on:click={() => showImage(img)}
          class="app-file"
          transition:fade={{ duration: 200 }}
        >
          <img class="app-file-img noselect" src={img.url} alt="" />

          <div class="app-file-label noselect">
            {img.title}
          </div>
          <div class="app-file-remove-size noselect">
            {`${img.width} x ${img.height}`}
          </div>
          <div
            class="app-file-remove"
            on:click|stopPropagation={() => removeFileHandler(img)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="ionicon"
              viewBox="0 0 512 512"
              ><title>{l["remove"]}</title><path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="32"
                d="M400 256H112"
              /></svg
            >
          </div>
          <div
            class="app-file-remove app-file-share"
            on:click|stopPropagation={() => shareImage(img)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="ionicon"
              viewBox="0 0 512 512"
              ><title>Share Social</title><path
                d="M384 336a63.78 63.78 0 00-46.12 19.7l-148-83.27a63.85 63.85 0 000-32.86l148-83.27a63.8 63.8 0 10-15.73-27.87l-148 83.27a64 64 0 100 88.6l148 83.27A64 64 0 10384 336z"
              /></svg
            >
          </div>
        </div>
      {/each}
    </div>
  {/if}
</div>
{#if imgFullPreview}
  <ImgFullPreview img={imgFullPreview} on:onClickImage={onClickImage} />
{/if}
